module.exports = __webpack_public_path__ + "img/header.624aba0.jpg";